export default __webpack_public_path__ + "static/media/Skyscanner-Logo.4cf85ad4.png";